module.exports = __webpack_public_path__ + "img/基准书数@3x.f1f9f1cf.png";